<app-header></app-header>

<section class="Headline ">
  <div class="container-div pt-5  ">
    <div>
      <h1 class="text-center text-edit word">{{'CODING-IS-FUN'|translate}}</h1>
      <h5 class="text-center edit-words">
        {{'have-to-join'|translate}}<br />
        {{'ROBOGARDEN-JOURNEY'|translate}}
      </h5>
    </div>
    <div class="d-flex justify-content-center">
      <img class="edit-com" src="assets_main/images/imageComputer.png" alt="" />
    </div>
  </div>
  <div class="container-div edit-section">
    <div>
      <img class="d-flex justify-content-center img-edit" src="assets_main/images/journey.png" alt="" *ngIf="!['es', 'pt'].includes(currentLang)">
      <img class="d-flex justify-content-center img-edit" src="assets_main/images/journey-text-es.png" alt="" *ngIf="currentLang === 'es'">
      <img class="d-flex justify-content-center img-edit" src="assets_main/images/journey-text-pt.png" alt="" *ngIf="currentLang === 'pt'">
      <h4 class="text-center edit-res text-black-50 mt-2">
        {{'course-content'|translate}}
      </h4>
      <h4 class="text-center edit-bg ">{{'AMAZING-ADVENTURES'|translate}}</h4>
    </div>
    <div class="d-flex justify-content-center">
      <img class="edit-adv" src="assets_main/images/adventure8.png" alt="" *ngIf="!['es', 'pt'].includes(currentLang)">
      <img class="edit-adv" src="assets_main/images/adventure-img-es.png" alt="" *ngIf="currentLang === 'es'">
      <img class="edit-adv" src="assets_main/images/adventure-img-pt.png" alt="" *ngIf="currentLang === 'pt'">
    </div>
  </div>
  <div class="container-div certificate">
    <h3 class="text-center word text-edit">
      {{'certificate-share'|translate}}
    </h3> 
    <h5 class="text-center edit-words">
     {{'free-certificate'|translate}} <br />
      {{'show-steps-earned'|translate}}
    </h5>
  </div>
  <div
    class="container-div certificate-content d-flex justify-content-around edit-certificate mt-5"
  >
    <img class="edit-width" src="assets_main/images/certificate1.jpg" alt="" *ngIf="!['es', 'pt'].includes(currentLang)">
    <img class="edit-width" src="assets_main/images/certificate2.jpg" alt="" *ngIf="!['es', 'pt'].includes(currentLang)">
    <img class="edit-width" src="assets_main/images/certificate3.jpg" alt="" *ngIf="!['es', 'pt'].includes(currentLang)">
    <img class="edit-width" src="assets_main/images/certificate1-es.jpg" alt="" *ngIf="currentLang === 'es'">
    <img class="edit-width" src="assets_main/images/certificate2-es.jpg" alt="" *ngIf="currentLang === 'es'">
    <img class="edit-width" src="assets_main/images/certificate3-es.jpg" alt="" *ngIf="currentLang === 'es'">
    <img class="edit-width" src="assets_main/images/certificate1-pt.jpg" alt="" *ngIf="currentLang === 'pt'">
    <img class="edit-width" src="assets_main/images/certificate2-pt.jpg" alt="" *ngIf="currentLang === 'pt'">
    <img class="edit-width" src="assets_main/images/certificate3-pt.jpg" alt="" *ngIf="currentLang === 'pt'">
  </div>
  <div class="d-flex justify-content-center mt-5">
    <!-- <img class="edit-quiz" src="assets_main/images/quiz.png" alt="" /> -->
    <img class="edit-quiz" src="assets_main/images/certificate1.jpg" alt="" *ngIf="!['es', 'pt'].includes(currentLang)">
    <img class="edit-quiz" src="assets_main/images/certificate1-es.jpg" alt="" *ngIf="currentLang === 'es'">
    <img class="edit-quiz" src="assets_main/images/certificate1-pt.jpg" alt="" *ngIf="currentLang === 'pt'">
  </div>
</section>
<app-subscribe></app-subscribe>
<app-footer></app-footer>
